// src/utils/monthUtils.js

export function getMonthName(monthIndex) {
  switch (monthIndex) {
    case 0: return "Jan";
    case 1: return "Feb";
    case 2: return "Mar";
    case 3: return "Apr";
    case 4: return "May";
    case 5: return "Jun";
    case 6: return "Jul";
    case 7: return "Aug";
    case 8: return "Sep";
    case 9: return "Oct";
    case 10: return "Nov";
    case 11: return "Dec";
    default: return "";
  }
}

export function getTimeSeriesLabels(date = new Date()) {
  const currentMonth = date.getMonth(); // 0-based
  const currentYear = date.getFullYear();

  const lastYearSameMonth =
    `${getMonthName(currentMonth)} ${currentYear - 1}`;

  const currentMonthLabel =
    `${getMonthName(currentMonth)} ${currentYear}`;

  const prevMonthDate = new Date(currentYear, currentMonth - 1, 1);
  const prevMonthLabel =
    `${getMonthName(prevMonthDate.getMonth())} ${prevMonthDate.getFullYear()}`;

  return {
    lastYearSameMonth,
    currentMonthLabel,
    prevMonthLabel
  };
}
